<template>

<div class="content-wrap">
    <template  v-for="(submenu, keiy) in menuItems">
        
        <template v-if="keiy.trim()==menuParent">
            <article  v-for="(subitems, keiyi) in submenu" :key="keiyi" class="blog-entry-travel animate-box">
                <!--<div class="blog-img" style="background-image: url('"+CONTENT_DOMAIN+"/img/modules/"+subitems+".jpg');"></div>-->
                <div class="blog-img" :style="'background-image: url('+CONTENT_DOMAIN+'/img/modules/'+subitems+'.jpg)'"></div>
                <div class="desc">
                    <p class="meta">
                        <span class="cat">
                            <router-link :to="'/module/'+subitems" >{{languageData['m'+subitems]}}</router-link>
                            <!--<a href="">{{languageData['m'+subitems]}}</a>-->
                        </span>											
                    </p>
                    
                </div>
            </article>
        </template> 
    </template>
    <!--<article class="blog-entry-travel animate-box">
        <div class="blog-img" style="background-image: url(../ThemeMegazine/images/blog-2.jpg);"></div>
        <div class="desc">
            <p class="meta">
                <span class="cat"><a href="#">Child Care Test Long Text</a></span>
                
            </p>
            
        </div>
    </article>-->
    
</div>

<!--
    <div class="vg-page theme-orange" :id="menuParent">
        
        <div class="vg-wrapper">
            <h2 v-html="languageData['d'+menuParent]"></h2>
            <hr class="theme-style">
            <section class="vg-blog">
                <div class="vg-post-list row">
                   
                    
                    <div class="col-md-6 col-lg-4" v-for="(subitems, keiy) in submenu" :key="keiy"  >
                        <div class="article" id="post-1">
                            
                            <a href="#module" class="img-place">
                                <img :src="CONTENT_DOMAIN+'/img/modules/'+subitems+'.jpg'" alt="" @click="call_module_details(subitems+'_'+menuParent)">
                            </a>
                            <div class="caption">
                                <a href="#module" class="post-title" ><span @click="call_module_details(subitems+'_'+menuParent)">{{languageData['m'+subitems]}} </span></a>
                                </div>
                           
                        </div>
                    </div>
                   
                   
                </div>
                
            </section>
        </div>
    </div>-->

</template>

<script>
    import {CONTENT_DOMAIN} from '@/constants/general_constants';
  import axios from 'axios';
  
  export default {
    name: 'DivisionTiles',
   /* props:['parentMenuId','iCount','subMenu'],*/
	data() {
           
        return {          
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            //menuParent:this.parentMenuId,            
            menuParent:this.$route.params.division_id
            //subMenus:[]         
        }

    },
    
    components: {
     },
    watch: { 
        // call again the method if the route changes
        '$route': 'showContent'        
        
    },
    computed:{  
        
            menuItems(){return this.$store.state.menuVar;},
            languageData() {return this.$store.state.languageData;}  
           // subMenus(){return this.menuItems[this.menuParent]}
        },
    mounted :function(){
        //console.log('ooo',this.CONTENT_DOMAIN) 
        //this.showDivisions()
        //console.log('divisionID-',this.menuParent) 
        //if(this.jqload_count==1){
        //console.log(this.$store.state.menuVar)
            
        //}  
        
		},
	methods:{
        showContent(){
            //this.menuParent : this.$route.params.division_id
            this.menuParent =this.$route.params.division_id
            console.log('watch call---'+this.menuParent) ;
            //location.reload();
        }


    }
  }
</script>

<style scoped>
.blog-entry-travel .desc {
    width: 0%;
    padding: 5em 0em 6em 0em;;
    margin: 0;
    background: #fafafa;
}
article .desc .meta span {
    
    margin-bottom: 0 !important;
}
article {
    width: 334px;
    float: left;
    margin-bottom: 2em;
    /* float: left; */
    margin-right: 1em;
}
.blog-entry-travel .blog-img {
    width: inherit !important;
}

.blog-entry-travel .desc .meta {    
    background: #ffffffd9;
    right: 0;
    min-width: 165px;
}

article .desc .meta {
    left: auto;
}

@media screen and (max-width: 768px){
    .blog-entry-travel .desc .meta {
        top: 20px !important;
        position: absolute !important;
        text-align: right;
    }
   
}
    
</style>
